import React from 'react';
import FieldContainer from 'components/pure/utils/form/FieldContainer';
import InputField from 'components/pure/utils/form/InputField';

export default class QuestionTitleInput extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      text: props.text || '',
    };
  }

  UNSAFE_componentWillReceiveProps({text}) {
    this.setState({text});
  }

  render() {
    const {index, onChange, showErrors, error} = this.props;
    return (
      <FieldContainer error={showErrors && error.text}>
        <InputField
          value={this.state.text}
          onBlur={() => onChange(index, 'text', this.state.text.trim())}
          onChange={val => this.setState({text: val})}
        />
      </FieldContainer>
    );
  }
}
